import React from "react";
import { LINE } from "../bureauTokens";

// Reprend .card de styles.css exactement (bg blanc, bordure LINE, radius
// 12px, padding 14px 16px) — la carte de base utilisée par toutes les
// sections du Bureau (file de priorité, récap, RDV, raccourcis, notes).
function BureauCard({ children, className = "" }) {
  return (
    <div
      className={className}
      style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 12, padding: "14px 16px" }}
    >
      {children}
    </div>
  );
}

export default BureauCard;
